module.exports = __webpack_public_path__ + "static/1.75f26d0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/1.jpg
// module id = 655
// module chunks = 196067925415476